import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
// Images
import bgImage from "assets/images/bd-Sign-HRM.jpg";
import { useNavigate } from "react-router-dom";
import { GET, POST } from "../../../APIclient";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputAdornment, IconButton } from "@mui/material";
import bntLogo from "assets/images/Bnt_logo.png";
import { formatDesignation } from "constants/ApplicationConstants";
import properties from "constants/ApplicationConstants";
import { Link } from "react-router-dom";
import { Snackbar, Alert, Button, TextField } from "@mui/material";

function Basic() {
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  let navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbar(false);
  };

  const [passwordVisibility, setPasswordVisibility] = useState(false);

  const handleClickShowPassword = () => {
    setPasswordVisibility(!passwordVisibility);
  };

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const handleSignIn = async e => {
    e.preventDefault();
    setIsLoading(true);

    setMessage("");
    setIsError(false);

    try {
      const req = JSON.stringify({
        username: username,
        password: password
      });

      const url = `api/login`;
      const response = await POST(url, req);
      let data = response.data ? response.data.data : response;
      setUserData(data);

      // setMessage(response?.data?.message || "Login Successful.");
      // setOpenSnackbar(true);
      // setIsError(false);

      localStorage.setItem("login_response", JSON.stringify(response.data));
      sessionStorage.setItem("login_response_auth", JSON.stringify(response.data));
      localStorage.setItem("login_response_auth", JSON.stringify(response.data));

      const token = data.jwtToken;
      const refreshToken = data.refreshToken;
      const expirationTime = data.expirationTime;
      localStorage.setItem("jwtToken", token);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("expirationTime", Date.now() + expirationTime);
      window.sessionStorage.setItem("jwtToken", token);
      window.sessionStorage.setItem("refreshToken", refreshToken);
      window.sessionStorage.setItem("expirationTime", Date.now() + expirationTime);

      const empId = data.empId;
      if (empId != null) {
        const employeeDetailsResponse = await GET(`admin/get-employee-details?empId=${empId}`);
        const employeeDetails = employeeDetailsResponse?.data?.data;
        localStorage.setItem("EmpName", employeeDetails.firstName + " " + employeeDetails.lastName);
        localStorage.setItem(
          "currentDesignation",
          formatDesignation(employeeDetails.currentDesignation)
        );
        localStorage.setItem("photoBase64", employeeDetails.photoBase64);
        localStorage.setItem("resignationApprovedStatus", employeeDetails.resignationApprovedStatus || 0);
        localStorage.setItem("resignationEndDate", employeeDetails.resignationEndDate || "");
        localStorage.setItem("joiningDate", employeeDetails.joiningDate || "");
        localStorage.setItem("reportingManagerName",employeeDetails.reportingManagerName || "");

      
        window.sessionStorage.setItem(
          "EmpName",
          employeeDetails.firstName + " " + employeeDetails.lastName
        );
        window.sessionStorage.setItem(
          "currentDesignation",
          formatDesignation(employeeDetails.currentDesignation)
        );
        window.sessionStorage.setItem("photoBase64", employeeDetails.photoBase64);
      }
      if (data?.reportFlag > 0 && data?.role === "it_admin_manager") {
        localStorage.setItem("empId", JSON.stringify(data.empId));
        localStorage.setItem("username", JSON.stringify(data.username));
        window.sessionStorage.setItem("empId", JSON.stringify(data.empId));
        window.sessionStorage.setItem("username", JSON.stringify(data.username));
        setRole("IT_Admin_Manager");
        localStorage.setItem("userType", JSON.stringify("IT_Admin_Manager"));
      } else if (data?.reportFlag === 0 && data?.role === "it_admin_employee") {
        localStorage.setItem("empId", JSON.stringify(data.empId));
        localStorage.setItem("username", JSON.stringify(data.username));
        window.sessionStorage.setItem("empId", JSON.stringify(data.empId));
        window.sessionStorage.setItem("username", JSON.stringify(data.username));
        setRole("IT_Admin_Employee");
        localStorage.setItem("userType", JSON.stringify("IT_Admin_Employee"));
      } else if (data && data.reportFlag === 0) {
        localStorage.setItem("empId", JSON.stringify(data.empId));
        localStorage.setItem("username", JSON.stringify(data.username));
        window.sessionStorage.setItem("empId", JSON.stringify(data.empId));
        window.sessionStorage.setItem("username", JSON.stringify(data.username));
        setRole("Employee");
        localStorage.setItem("userType", JSON.stringify("Employee"));
      } else if(data?.role === "finance_manager") {
        localStorage.setItem("empId", JSON.stringify(data.empId));
        localStorage.setItem("username", JSON.stringify(data.username));
        window.sessionStorage.setItem("empId", JSON.stringify(data.empId));
        window.sessionStorage.setItem("username", JSON.stringify(data.username));
        setRole("Finance_Manager");
        localStorage.setItem("userType", JSON.stringify("Finance_Manager"));
      } else if (data && data.reportFlag > 0) {
        localStorage.setItem("empId", JSON.stringify(data.empId));
        localStorage.setItem("username", JSON.stringify(data.username));
        window.sessionStorage.setItem("empId", JSON.stringify(data.empId));
        window.sessionStorage.setItem("username", JSON.stringify(data.username));
        setRole("Manager");
        localStorage.setItem("userType", JSON.stringify("Manager"));
      } else {
        localStorage.removeItem("empId");
        window.sessionStorage.removeItem("empId");

        localStorage.setItem("username", JSON.stringify(data.username));
        window.sessionStorage.setItem("username", JSON.stringify(data.username));
        setRole("Admin");
        localStorage.setItem("userType", JSON.stringify("Admin"));
      }
      navigate("/dashboard");
    } catch (error) {
      if (error.response?.status === 401) {
        setMessage("Invalid password. Please try again.");
        setOpenSnackbar(true);
        setIsError(true);
      } else {
        setMessage("Invalid password. Please try again.");
        setOpenSnackbar(true);
        setIsError(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          sx={{ backgroundColor: "rgba(0, 123, 255, 0.45)" }}
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={2}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
          <Grid container spacing={0} justifyContent="center" sx={{ mt: 1 }}>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
            >
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <img src={bntLogo} alt="BNT_SOFT" style={{ width: "70px" }} />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              {/* <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <FacebookIcon color="inherit" />
              </MDTypography> */}
            </Grid>
            <Grid item xs={2}>
              {/* <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GitHubIcon color="inherit" />
              </MDTypography> */}
            </Grid>
            <Grid item xs={2}>
              {/* <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GoogleIcon color="inherit" />
              </MDTypography> */}
            </Grid>
          </Grid>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSignIn}>
            <MDBox mb={2}>
              <MDInput
                type="text"
                value={username}
                onChange={e => setUserName(e.target.value)}
                label="Username"
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type={passwordVisibility ? "text" : "password"}
                value={password}
                onChange={e => {
                  setPassword(e.target.value);
                }}
                label="Password"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleClickShowPassword} edge="end">
                        {passwordVisibility ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                sx={{
                  "& input::-ms-reveal": {
                    display: "none"
                  },
                  "& input::-ms-clear": {
                    display: "none"
                  }
                }}
              />
            </MDBox>
            <MDBox textAlign="right" mb={2}>
              <MDTypography
                component={Link}
                to="/authentication/forgot-password"
                variant="button"
                color="info"
                fontWeight="medium"
                sx={{ cursor: "pointer" }}
              >
                Forgot password?
              </MDTypography>
            </MDBox>
            {/* <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{cursor: "pointer", userSelect: "none", ml: -1}}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>
            </MDBox> */}
            <MDBox mt={3} mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                type="submit"
                sx={{ background: properties.colors.bgcolorbluethem }}
                disabled={!username || !password || isLoading}
              >
                {isLoading ? "Signing in..." : "Sign in"}
              </MDButton>
            </MDBox>
            {/* <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Don't have an account?{" "}
                <MDTypography
                  component={MuiLink}
                  to="/authentication/sign-up"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Sign up
                </MDTypography>
              </MDTypography>
            </MDBox> */}
          </MDBox>
        </MDBox>
      </Card>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={isError ? "error" : "success"}
          variant="filled"
          sx={{ width: "100%", color: "#fff" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </BasicLayout>
  );
}

export default Basic;
